<div id="editViewGtinDialog" class="modal modal-lg modal-dialog fade in" role="dialog" style="display: none;position:absolute !important" appDraggable dragTarget="#editViewGtinDialog" dragHandle="#editViewGtinDialogHeader">
  <div class="modal-content">
    <div class="modal-header" id="editViewGtinDialogHeader" *ngIf="editgtinDetails.id != null">
        <button type="button" class="close"  data-dismiss="modal" (click)="hide()"><i class="fa fa-times" aria-hidden="true"></i></button>
		EDIT SET : {{editgtinDetails.gtin14}}
    </div>

    <div class="modal-header" id="editViewGtinDialogHeader" *ngIf="editgtinDetails.id == null">
        <button type="button" class="close"  data-dismiss="modal" (click)="hide()"><i class="fa fa-times" aria-hidden="true"></i></button>
		ADD SET
    </div>

    <div class="modal-body internal-well">
		<div class="form-group" >
			<div class="row">
				<div class="col-sm-2"><label for="name" class="labelRequired">GTIN-14: </label></div>
				<div class="col-sm-5"><input class="form-control" type="text" minlength="12" maxlength="14"   [(ngModel)]="editgtinDetails.gtin14"/></div>
			</div>
		</div>
		
		<br>
		
		<div class="form-group" >
			<div class="row">
				<div class="col-sm-2"><label for="name" class="labelRequired">PERCENTAGE UNDER: </label></div>
				<div class="col-sm-5"><input class="form-control" type="text" [(ngModel)]="editgtinDetails.minPercentage"  /></div>
			</div>
		</div>
        <br>
        <div class="form-group" >
			<div class="row">
				<div class="col-sm-2"><label for="name" class="labelRequired">PERCENTAGE OVER: </label></div>
				<div class="col-sm-5"><input class="form-control" type="text" [(ngModel)]="editgtinDetails.maxPercentage" /></div>
			</div>
		</div>
	</div>

    <div class="modal-footer">
		<button type="button" class="btn btn-default" (click)="onCancelClicked()" [disabled]="isUiDisabled"><i class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
		<button type="button" *ngIf="editgtinDetails.id != null" class="btn btn-primary" (click)="createOrUpdateGtinSetDetails()" [disabled]="isUiDisabled"><i class="fa fa-ban" aria-hidden="true"></i> UPDATE</button>
        <button type="button" *ngIf="editgtinDetails.id == null" class="btn btn-primary" (click)="createOrUpdateGtinSetDetails()" [disabled]="isUiDisabled"><i class="fa fa-ban" aria-hidden="true"></i> CREATE</button>
    </div>
  </div>
</div>
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>


